import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import SwiperOnlyH5 from '../common/Banner/SwiperOnlyH5';
import styles from './index.module.scss';

const BuiltTough: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('BuiltTough');

    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753685220662/1-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753685221396/1-pad.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753685220949/1-h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753685220731/2-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753685221158/2-pad.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753685220401/2-h5.jpg',
        },
    ];
    return (
        <div className={`${styles.BuiltTough} GtmModuleData-section`} data-section-id="BuiltTough" id="BuiltTough">
            <EcoSpace hPc="180px" />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="trail-layout box">
                <SwiperOnlyH5 items={items} />
                {/* <EcoImg className="img-1" pc="https://websiteoss.ecoflow.com/upload/image/1752139442182/1-pc.jpg" />
                <EcoImg className="img-2" pc="https://websiteoss.ecoflow.com/upload/image/1752139441947/2-pc.jpg" /> */}
            </div>
        </div>
    );
};

export default BuiltTough;
